import React, {lazy, Suspense} from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Route from "./Route";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import {TelegramProvider} from "../context/Telegram/TelegramContext";

import LoggedInLayout from "../layout";

import Login from "../pages/Login";
import LoadingPage from "../pages/LoadingPage";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Tickets = lazy(() => import("../pages/Tickets"));
const Connections = lazy(() => import("../pages/Connections"));
const Settings = lazy(() => import("../pages/Settings"));
const Users = lazy(() => import("../pages/Users"));
const Contacts = lazy(() => import("../pages/Contacts"));
const QuickAnswers = lazy(() => import("../pages/QuickAnswers"));
const Queues = lazy(() => import("../pages/Queues"));
const Tags = lazy(() => import("../pages/Tags"));
const TicketsBot = lazy(() => import("../pages/TicketsBot"));
const Perguntas = lazy(() => import("../pages/PerguntasRespostas"));
const EnvioMassa = lazy(() => import("../pages/EnvioMassa"));
const Agendamentos = lazy(() => import("../pages/Agendamentos"));
const Protocolos = lazy(() => import("../pages/Protocolos"));
const Nps = lazy(() => import("../pages/Nps"));
const Reports = lazy(() => import("../pages/Reports"));
const Templates = lazy(() => import("../pages/Templates"));
const ContDoc = lazy(() => import("../pages/ContDoc"));
const Logs = lazy(() => import("../pages/Logs"));

const FacebookCallback = lazy(() =>
  import("../components/FacebookCallback")
);

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/meta/onboarding/callback" component={FacebookCallback} />
          {/*<Route exact path="/signup" component={Signup} />*/}
          <WhatsAppsProvider>
            <TelegramProvider>
              <LoggedInLayout>
                <Suspense fallback={<LoadingPage />} >
                  <Route exact path="/" component={Dashboard} isPrivate />
                  <Route exact path="/templates" component={Templates} isPrivate />
                  <Route
                    exact
                    path="/tickets/:ticketId?/:chatId?"
                    component={Tickets}
                    isPrivate
                  />
                  <Route
                    exact
                    path="/connections"
                    component={Connections}
                    isPrivate
                  />
                  <Route exact path="/contacts" component={Contacts} isPrivate />

                  <Route exact path="/users" component={Users} isPrivate />

                  <Route
                    exact
                    path="/ticketsBot"
                    component={TicketsBot}
                    isPrivate
                  />

                  <Route
                    exact
                    path="/perguntas"
                    component={Perguntas}
                    isPrivate
                  />

                  <Route
                      exact
                      path="/envios"
                      component={EnvioMassa}
                      isPrivate
                  />

                  <Route
                      exact
                      path="/agendamentos"
                      component={Agendamentos}
                      isPrivate
                  />

                  <Route
                    exact
                    path="/quickAnswers"
                    component={QuickAnswers}
                    isPrivate
                  />

                  <Route
                    exact
                    path="/protocolos"
                    component={Protocolos}
                    isPrivate
                  />
                  <Route exact path="/contdoc" component={ContDoc} isPrivate />
                  <Route exact path="/Settings" component={Settings} isPrivate />
                  <Route exact path="/Queues" component={Queues} isPrivate />
                  <Route exact path="/Nps" component={Nps} isPrivate />
                  <Route exact path="/logs" component={Logs} isPrivate />
                  <Route exact path="/report" component={Reports} isPrivate />
                  <Route exact path="/tags" component={Tags} isPrivate />
                </Suspense>
              </LoggedInLayout>
            </TelegramProvider>
          </WhatsAppsProvider>
        </Switch>
        <ToastContainer style={{ width: "400px"}} autoClose={3000} />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
